import {UseMutateFunction, useMutation, useQueryClient} from '@tanstack/react-query';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {logout, logoutFromAllUserSessions} from '../../../../service/authorization';
import {setLoggedInUserAction} from '../../../../store/actions/auth';
import {startPageSpinnerAction, stopPageSpinnerAction} from '../../../../store/actions/spinner';

export const useLogout = (logoutAll?: boolean): UseMutateFunction<boolean, unknown, void, void> => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const {mutate: logoutFn} = useMutation(() => (logoutAll ? logoutFromAllUserSessions() : logout()), {
        onMutate: () => {
            dispatch(startPageSpinnerAction());
        },
        onSuccess: () => {
            queryClient.clear();
            dispatch(setLoggedInUserAction(undefined));
            navigate('/login');
        },
        onSettled: () => {
            dispatch(stopPageSpinnerAction());
        },
    });

    return logoutFn;
};
